import React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatContentWithEmoji } from '../alert';

const PaymentSent = (props) => {
  return (
    <div>
      <div className="modal-section modal-title text-center blue full">
        <h1>
          <FormattedMessage
            id="paymentSent.title"
            defaultMessage="Purchase in progress"
          />
        </h1>
      </div>
      <div className="modal-section divider pb-5">
        <h3>
          <FormattedMessage
            id="paymentSent.confirming"
            defaultMessage="{merchant} is confirming your payment. This could take up to 24 hrs."
            values={{ merchant: props.merchantName }}
          />
        </h3>
        <p className="text-muted">
          {
            formatContentWithEmoji(
              <FormattedMessage
                id="paymentSent.youWillReceiveEmailConfirmation"
                defaultMessage="You will receive a final confirmation or notification of any issues via email."
              />,
              '📬',
            )
          }
        </p>
      </div>
      <div className="modal-section divider py-5 mb-4">
        <p className="mb-4">
          <FormattedMessage
            id="paymentSent.inTheMeantime"
            defaultMessage="In the meantime, sit back and relax!
              Being an organizer is a big responsibility, but you made it! {icon}"
            values={{
              icon: <span role="img" aria-label="" className="ml-1">🎉</span>,
            }}
          />
        </p>
        <p>
          <FormattedMessage
            id="paymentSent.youAreOurFavorite"
            defaultMessage="Just between us, you're our favorite organizer! Just don't tell the others {icon}"
            values={{ icon: <span role="img" aria-label="" className="ml-1">😉</span> }}
          />
        </p>
      </div>
      <button
        className="btn btn-primary pull-right"
        type="button"
        onClick={props.onCloseClick}
      >
        <FormattedMessage
          id="paymentSent.button"
          defaultMessage="Cool!"
        />
      </button>
    </div>
  );
};

PaymentSent.defaultProps = {
  onCloseClick: () => {},
  merchantName: '[Merchant Name]',
};

export default PaymentSent;



// WEBPACK FOOTER //
// ./src/desktop/components/make-purchase/payment-sent.js